module.exports = __webpack_public_path__ + "static/img/fb.2d54de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fb.png
// module id = +syn
// module chunks = 1